import {Reason} from '../reason.ts';

export type ExceptionData = Partial<Reason> & {
    [key: string]: unknown
}

export class ExceptionInfo extends Error {
    readonly data: ExceptionData;
    readonly cause: unknown;
    constructor(message: string, data: ExceptionData, cause?: unknown) {
        super(message);
        this.name = 'ExceptionInfo';
        this.data = data;
        this.cause = cause;
    }
}

export function exceptionInfo(msg: string, data: ExceptionData, cause?: unknown) {
    return new ExceptionInfo(msg, data, cause);
}


export function exceptionData(ex: unknown): ExceptionData | undefined {
    if (ex instanceof ExceptionInfo) {
        return ex.data;
    }
}


export function exceptionMessage(ex: unknown): string | undefined {
    if (ex instanceof Error) {
        return ex.message;
    }
}

export function exceptionCause(ex: unknown): unknown {
    if (ex instanceof ExceptionInfo) {
        return ex.cause;
    }
}
